<template>
  <transition name="fade">
    <svg class="loader" viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
      <circle class="loader-circle" fill="none" stroke-width="2" stroke-linecap="round" cx="50" cy="50" r="20"></circle>
    </svg>
  </transition>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss">
.loader {
  stroke: black;
  animation: loaderRotate 1.4s linear infinite;
  width: 50px;
  height: 50px;

  .loader-circle {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: loaderTurn 1.4s ease-in-out infinite;
  }
}

@keyframes loaderRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loaderTurn {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
};
</style>
